import * as actionTypes from "../../actions/actionTypes";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  isVisible: false // Default to not visible, will be auto-activated when clusters are available
};

const radarClustersReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.RADAR_CLUSTERS_INIT:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case actionTypes.RADAR_CLUSTERS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        error: null
      };
    case actionTypes.RADAR_CLUSTERS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case actionTypes.RADAR_CLUSTERS_TOGGLE:
      return {
        ...state,
        isVisible: false // Force disabled for production. Toggle requests are ignored.
      };
    default:
      return state;
  }
};

export default radarClustersReducer;